module.exports = __webpack_public_path__ + "media/images/new-ui-images/filter-0ed91d0bdd31146467bc19cd1fa55b67.svg";